export default __webpack_public_path__ + "static/media/ticket_template.e0ce0d23.svg";